import(/* webpackMode: "eager" */ "/var/www/next-frontend/src/app/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/next-frontend/src/components/common/layouts/MainLayout.js");
